import { gql } from "@apollo/client";

export const GET_PRICING_PLANS = gql`
  query GetPricingPlans {
    pricingPlans {
      id
      name
      displayName
      description
      setupFee
      setupFeeCurrency
      setupFeePrices {
        currency
        amount
        chatAmount
        callAmount
      }
      prices {
        currency
        monthlyPrice
        yearlyPrice
        stripePriceIdMonthly
        stripePriceIdYearly
        razorpayPlanIdMonthly
        razorpayPlanIdYearly
      }
      features {
        name
        included
        limit
      }
      isPopular
      isActive
      sortOrder
      trialDays
    }
  }
`;

export const GET_SUBSCRIPTION_BILLING_CURRENCIES = gql`
  query GetSubscriptionBillingCurrencies {
    subscriptionBillingCurrencies
  }
`;

export const GET_MY_SUBSCRIPTION = gql`
  query GetMySubscription {
    mySubscription {
      id
      organization {
        id
        name
      }
      stripeCustomerId
      stripeSubscriptionId
      stripePriceId
      razorpayCustomerId
      razorpaySubscriptionId
      razorpayPlanId
      provider
      shopifyChargeId
      shopifyStatus
      shopifyConfirmationUrl
      plan
      status
      currency
      amount
      billingCycle
      currentPeriodStart
      currentPeriodEnd
      trialStart
      trialEnd
      cancelAtPeriodEnd
      canceledAt
      metadata
      createdAt
      updatedAt
    }
  }
`;

export const GET_MY_ORGANIZATION_SETUP_FEE_STATUS = gql`
  query GetMyOrganizationSetupFeeStatus($organizationId: ID) {
    myOrganizationSetupFeeStatus(organizationId: $organizationId) {
      alreadyPaid
      amount
      currency
      chargedAt
    }
  }
`;

export const CREATE_SUBSCRIPTION = gql`
  mutation CreateSubscription($userId: ID!, $priceId: String!, $paymentMethodId: String, $savedPaymentMethodId: ID, $applySetupFee: Boolean, $setupFeeServices: [SetupFeeService!]) {
    createSubscription(userId: $userId, priceId: $priceId, paymentMethodId: $paymentMethodId, savedPaymentMethodId: $savedPaymentMethodId, applySetupFee: $applySetupFee, setupFeeServices: $setupFeeServices) {
      id
      organization {
        id
        name
      }
      stripeCustomerId
      stripeSubscriptionId
      stripePriceId
      razorpayCustomerId
      razorpaySubscriptionId
      razorpayPlanId
      provider
      shopifyChargeId
      shopifyStatus
      plan
      status
      currency
      amount
      billingCycle
      currentPeriodStart
      currentPeriodEnd
      trialStart
      trialEnd
      cancelAtPeriodEnd
      canceledAt
      metadata
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_SUBSCRIPTION = gql`
  mutation UpdateSubscription($userId: ID!, $subscriptionId: String!, $newPriceId: String!, $paymentMethodId: String, $savedPaymentMethodId: ID, $applySetupFee: Boolean, $setupFeeServices: [SetupFeeService!]) {
    updateSubscription(userId: $userId, subscriptionId: $subscriptionId, newPriceId: $newPriceId, paymentMethodId: $paymentMethodId, savedPaymentMethodId: $savedPaymentMethodId, applySetupFee: $applySetupFee, setupFeeServices: $setupFeeServices) {
      id
      organization {
        id
        name
      }
      stripeCustomerId
      stripeSubscriptionId
      stripePriceId
      plan
      status
      currency
      amount
      billingCycle
      currentPeriodStart
      currentPeriodEnd
      trialStart
      trialEnd
      cancelAtPeriodEnd
      canceledAt
      metadata
      createdAt
      updatedAt
    }
  }
`;

export const CANCEL_SUBSCRIPTION = gql`
  mutation CancelSubscription($userId: ID!, $subscriptionId: String!, $cancelAtPeriodEnd: Boolean = true) {
    cancelSubscription(userId: $userId, subscriptionId: $subscriptionId, cancelAtPeriodEnd: $cancelAtPeriodEnd) {
      id
      organization {
        id
        name
      }
      stripeCustomerId
      stripeSubscriptionId
      stripePriceId
      plan
      status
      currency
      amount
      billingCycle
      currentPeriodStart
      currentPeriodEnd
      trialStart
      trialEnd
      cancelAtPeriodEnd
      canceledAt
      metadata
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_CHECKOUT_SESSION = gql`
  mutation CreateCheckoutSession($input: CreateCheckoutSessionInput!) {
    createCheckoutSession(input: $input) {
      id
      url
      provider
    }
  }
`;

export const CREATE_BILLING_PORTAL_SESSION = gql`
  mutation CreateBillingPortalSession {
    createBillingPortalSession {
      id
      url
    }
  }
`;

export const GET_PAYMENT_METHODS = gql`
  query GetPaymentMethods {
    myPaymentMethods {
      id
      stripePaymentMethodId
      type
      brand
      last4
      expMonth
      expYear
      isDefault
      createdAt
    }
  }
`;

export const ADD_PAYMENT_METHOD = gql`
  mutation AddPaymentMethod($paymentMethodId: String!) {
    addPaymentMethod(paymentMethodId: $paymentMethodId) {
      id
      stripePaymentMethodId
      type
      brand
      last4
      expMonth
      expYear
      isDefault
      createdAt
    }
  }
`;

export const DELETE_PAYMENT_METHOD = gql`
  mutation DeletePaymentMethod($id: ID!) {
    deletePaymentMethod(id: $id)
  }
`;

export const SET_DEFAULT_PAYMENT_METHOD = gql`
  mutation SetDefaultPaymentMethod($id: ID!) {
    setDefaultPaymentMethod(id: $id) {
      id
      stripePaymentMethodId
      isDefault
    }
  }
`;
